import React, { useState } from 'react';
import LogoutIcon from '@mui/icons-material/Logout';
import { Avatar, Menu, MenuItem, IconButton, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import arcLogo from '@/assets/images/arcweb.svg';
import headerStyles from '@/components/organisms/Header/header.module.css';
import { selectUser } from '@/store/auth/selectors';

interface NavItem {
  text: string;
  onClick: () => void;
}

interface HeaderProps {
  title: string;
  navigationItems?: NavItem[];
}

const Header: React.FC<HeaderProps> = ({ navigationItems = [] }) => {
  // const dispatch = useDispatch();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const userData = useSelector(selectUser);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    // dispatch(logout());
    localStorage.removeItem('token');
    window.location.href = '/';
    handleMenuClose();
    navigate('/login');
  };

  return (
    <div className={headerStyles.base}>
      <div className={headerStyles.logo}>
        <img src={arcLogo} alt="data-image" />
      </div>

      {navigationItems && navigationItems.length > 0 && (
        <nav className={headerStyles.navigation}>
          {navigationItems.map((item, index) => (
            <button key={index} onClick={item.onClick} className={headerStyles.element}>
              {item.text}
            </button>
          ))}
        </nav>
      )}

      <div className={headerStyles.profile}>
        <Button
          onClick={handleMenuOpen}
          startIcon={
            <Avatar className={headerStyles.avatar} sx={{ width: 32, height: 32 }}>
              {userData?.first_name?.[0]}
              {userData?.last_name?.[0]}
            </Avatar>
          }
          sx={{ textTransform: 'none' }}
        >
          <span className={headerStyles.username}>
            {userData?.first_name} {userData?.last_name}
          </span>
        </Button>
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          onClick={handleMenuClose}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleLogout}>
            <LogoutIcon fontSize="small" />
            Logout
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
};

export default Header;
